import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	issuesHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	doneIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issuesHeadingIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noIssuesIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	issuesHeading: {
		id: 'version-progress.issues-heading.issues-heading',
		defaultMessage: 'Issues',
		description: "Title for a section of the UI that shows the progress of the releases's issues",
	},
	doneIssues: {
		id: 'version-progress.issues-heading.done-issues',
		defaultMessage: '{doneCount} of {totalCount} {totalCount, plural, one {done} other {done}}',
		description: 'Indicates the number of issues in the version that have been completed.',
	},
	noIssues: {
		id: 'version-progress.issues-heading.no-issues',
		defaultMessage: 'No issues added',
		description:
			'Message shown when there are no issues in the version. When there are issues, we instead show "X of Y done".',
	},
	issuesHeadingIssueTerminologyRefreshM4: {
		id: 'version-progress.issues-heading.issues-heading-issue-terminology-refresh-m4',
		defaultMessage: 'Work items',
		description: "Title for a section of the UI that shows the progress of the releases's issues",
	},
	noIssuesIssueTerminologyRefreshM4: {
		id: 'version-progress.issues-heading.no-issues-issue-terminology-refresh-m4',
		defaultMessage: 'No work items added',
		description:
			'Message shown when there are no issues in the version. When there are issues, we instead show "X of Y done".',
	},
});
export default messages;
